"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vouchers_1 = require("../../economy/vouchers");
const payment_plans_1 = require("../../economy/payment-plans");
const map = {
    is: {
        currently: 'sv',
    },
    mentionContent: {
        reminderFeeRow: 'Påminnelseavgift enligt räntelagen avsnitt 9b, punkt 2',
        debtCollectionFeeRow: 'Inkassoavgift enligt räntelagen avsnitt 9b, punkt 1',
        debtCollectionCostRow: 'Inkassokostnad enligt räntelagen avsnitt 9a, punkt 1',
        compensationFeeRow: 'Kompensationsavgift enligt räntelagen avsnitt 9a, punkt 3',
        fixedInterestRow: 'Tidigare ackumulerad ränta',
        processInterestRow: 'Ackumulerad ränta från förfallodagen',
        yearlyInterestRow: 'Ackumulerad ränta',
        otherCosts: 'Andra kostnader',
        sum: 'Totalt utestående',
        paid: 'Redan betald',
        invoice: 'Faktura',
        date: 'Datum',
        dueDate: 'Förfallodatum',
        amount: 'Belopp',
        email: 'E-post',
        phone: 'Telefon',
        signature: 'Signatur',
        journalNumber: 'Ärende:',
        genericEmailSubjectPre: 'Angående din skuld till',
        genericEmailSubjectForAlternativeContactPre: 'Ärende hos',
        satisfactionsOrClick: 'eller klicka',
        satisfactionsHere: 'här',
        principalReferenceIdsAnd: ' och ',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Tillbaka till ärende',
        paymentPlanOn: 'Betalningsplan på ärende',
        selectPlan: 'Välj betalningsplan',
        sign: 'Underteckna avtal',
        gatherInfo: 'Ange information',
        paymentMethod: 'Välj betalningsmetod',
        approval: 'Bekräftelse',
        info: 'Info',
        paymentPlan: 'Betalningsplan',
        firstPayment: 'Första betalning',
        entry: 'post',
        lastPayment: 'Sista betalning',
        signedDoc: 'Undertecknat dokument',
        needHelp: 'Behöver hjälp?',
        orPay: 'Eller betala hela skulden',
        pay: 'Betala hela skulden',
        months: 'Månader',
        month: 'månad',
        total: 'Total betalning',
        select: 'Välj',
        noOptions: 'Tyvärr går det inte att skapa en betalningsplan.',
        signTextOne: 'För att skriva upp dig på en betalningsplan med',
        signTextTwoAlternativeContact: 'måste gäldenären underteckna följande avtal.',
        signTextTwoDebtor: 'måste du underteckna följande avtal.',
        signTextThree: 'För att kunna underteckna avtalet måste du fylla i dina uppgifter.',
        agreement: 'Underteckna avtal',
        approvalText: 'Grattis. Du har ingått en betalningsplan.',
        paymentMethodText: 'Vi tar hand om dina kortuppgifter och gör det enkelt för dig att anmäla dig till automatisk betalning.',
        connectCard: 'Anslut betalningsmetod',
        automaticPaymentMethod: 'Automatisk betalningsmetod',
        deleteCardToChange: 'Du kan ändra/radera det valda kortet genom att klicka på knappen för att radera kortet.',
        deleteCard: 'Radera kort',
        paymentPlanEntries: 'Betalningsplanposter',
        amount: 'Belopp',
        date: 'Datum',
        status: 'Status',
        statusCode: {
            [payment_plans_1.PaymentPlanEntryStatus.SETTLED]: 'Betald',
            [payment_plans_1.PaymentPlanEntryStatus.CANCELED]: 'Misslyckad',
            [payment_plans_1.PaymentPlanEntryStatus.PENDING]: 'Kommande',
            [payment_plans_1.PaymentPlanEntryStatus.REMINDED]: 'Påmind',
            [payment_plans_1.PaymentPlanEntryStatus.AWAITING]: 'Väntar',
            [payment_plans_1.PaymentPlanEntryStatus.OVERDUE]: 'Försenad',
            [payment_plans_1.PaymentPlanEntryStatus.ERRORSETTLED]: 'Misslyckad kortdragning',
        },
    },
    emailSignature: {
        privacyPolicyText: 'Databehandling. Vi kan behandla personuppgifter om dig. Du kan läsa vår integritetspolicy här:',
        regards: 'Med vänliga hälsningar',
    },
    pluralEconomyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Kapitalbelopp',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Fakturor',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'Fakturor på konto',
        [vouchers_1.VoucherTypeIds.DOM]: 'Dom',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Slutgörelser',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Kontrollavgifter',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationskostnader',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Årliga räntor',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Räntor',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Ränta på ränta (daglig räntetillskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Ränta på ränta (månatlig räntetillskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Ränta på ränta (kvartalsvis räntetillskrivning)',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Räntor (GL)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Påminnelseavgifter',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Inkassokostnader',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Inkassoavgifter',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Kronofogdens avgifter',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Utredningsavgifter',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Domstolskostnader utan civil domstol',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Domstolslöner',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Kronofogdens löner',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Kronofogdens rekvisitionsavgifter',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Polisens presentationsavgifter',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Domstolskostnader med kronofogdens domstol',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Utredningslöner',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationskostnader',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Uppslag i folkbokföringen',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterialrättsliga ärenden',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Civila domstolskostnader',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Depositioner',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Uttag',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Överbetalningar',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassoprovisioner',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassoprovisioner (övervakning)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassoprovisioner (kreditorgaranti)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Juridiskt stöd',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'Avgifter för slutet av fallet',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Avgifter för starten av fallet',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK-avgifter',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Kronofogdens rekvisitionsavgifter',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registreringsavgifter',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Utredningsutgifter',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Polisens presentationsutgifter',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Kronofogdens rekvisitionsutgifter',
        [vouchers_1.VoucherTypeIds.VAT]: 'Moms',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Lån',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Förlikning',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Fast ränta',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Utträdesavgifter',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Uttag av deposition',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkbokföringsuppslag',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmälan av fordran',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Mötesavgifter',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Utredningsavgift',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Avgift för bokning',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Avbokning av utlägg',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Låssmedsavgift',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Körkostnader',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Övriga kostnader',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Återbetalning',
    },
    economyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Kapitalbelopp',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Faktura',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'Faktura på konto',
        [vouchers_1.VoucherTypeIds.DOM]: 'Dom',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Slutgiltig faktura',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Kontrollavgift',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationskostnad',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Årlig ränta',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Ränta',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Ränta (GL)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Ränta på ränta (daglig räntetillskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Ränta på ränta (månatlig räntetillskrivning)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Ränta på ränta (kvartalsvis räntetillskrivning)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Påminnelseavgift',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Inkassokostnad',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Inkassoavgift',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationskostnad',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Uppslag i folkbokföringen',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterialrättsliga ärenden',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Deposition',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Uttag',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Överbetalning',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassokommission',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassokommission (övervakning)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassokommission (klientdeposition)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Juridiskt bistånd',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'Avgift för avslut av ärende',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Avgift för start av ärende',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK-avgift',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitionsavgift',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registreringsavgift',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Utgifter för skriftlig befallning',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Utgifter för polisframställning',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Utgifter för fogedrekvisition',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Rättegångskostnader utan civilrätt',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Rättegångslön',
        [vouchers_1.VoucherTypeIds.VAT]: 'Moms',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Fogdeavgift',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Fogdelön',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Polisframställningsavgift',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Rättegångskostnader med fogderätt',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Kostnad för civilrätt',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsavgift',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Skriftlig avgift',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Skriftlig lön',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Lån',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Förlikning',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Fast ränta',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Avgift för uttag',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Uttag av deposition',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkbokföringsuppslag',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmälan av krav',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Mötesavgift',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Skriftlig avgift',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Bokningsavgift',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning av utlägg',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Låssmedsavgift',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Körkostnader',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Övriga avgifter',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Återbetalning',
    },
};
exports.default = map;
//# sourceMappingURL=sv.js.map